const Page404: React.FC = () => {
    return <div>404 Not Found</div>;
};

export default Page404;
